/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-props-no-multi-spaces */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-script-url */
/* eslint-disable no-script-url */
/* eslint-disable max-len */
import React, { useEffect } from 'react';
import ReactPaginate from 'react-paginate';

function Pagination(props) {
    const {
        totalPage, currentPage, handlePageClick, List, item, search, isSkeleton,
    } = props;

    // useEffect(() => {
    // }, [currentPage]);

    return (
        <div className="flex items-center justify-center" data-testid="paginator">

            <ReactPaginate
                previousLabel={(
                    <button
                        disabled={currentPage === 1}
                        type="button"
                        data-testid="paginator-previous"
                        className="mr-5 bg-[#EBEBEB] rounded-[5px] w-[27px] h-[27px] flex justify-center items-center"
                    >
                        {currentPage === 1 ? <img src="/images/chevrons-left.svg" alt="icon" /> : <img src="/images/Right-angle-icon.svg" alt="icon" className="image-rotate" />}

                    </button>
                )}
                nextLabel={(
                    <button
                        type="button"
                        data-testid="paginator-next"
                        className="ml-5 bg-[#EBEBEB] rounded-[5px] w-[27px] h-[27px] flex justify-center items-center cursor-pointer    "
                        disabled={currentPage === List?.pagination || Number(totalPage)}
                    >
                        {currentPage === List?.pagination || currentPage === totalPage ? <img src="/images/chevrons-left.svg" alt="icon" className="image-rotate" /> : <img src="/images/Right-angle-icon.svg" alt="icon" />}
                    </button>
                )}
                breakLabel="..."
                pageCount={List?.pagination || totalPage}
                marginPagesDisplayed={2}
                pageRangeDisplayed={3}
                forcePage={currentPage - 1}
                onPageChange={(val) => {
                    if (isSkeleton) {
                        const payload = Number(val.selected + 1);
                        handlePageClick(payload, List, item, search);
                    } else {
                        handlePageClick(val, List, item, search);
                    }
                }}
                containerClassName="flex items-center justify-center pb-5 pt-7"
                pageClassName="text-xs font-regular text-[#555259] ml-2 px-2 border border-transparent rounded-[5px] w-5 h-5 inline-flex justify-center items-center hover:bg-[#F2F2F3]  "
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                breakClassName="page-item"
                breakLinkClassName="page-link"
                activeClassName="bg-[#F2F2F3] "
            />
        </div>
    );
}

export default Pagination;
